import TriggerFileUpload from "../components/TriggerFileUpload";

export default class ResidentBusinessGuidesBusinessListingUploads {
  constructor(params) {
    this.params = params;
    this.toasting = false;
  }

  new() {
    new TriggerFileUpload();
    if (this.params.failed) {
      $(".js-address-upload-failed-modal").modal();
      $(".modal-backdrop").addClass("in");
    }
  }
}
